import axiosMultipartInstance from "~/shared/api/axios-multipart-instance";

interface CreateCameraResponse {
  id: number; // pseudo_camera id
  default_cam_id: string;
  branch_uid: string;
  pseudo_camera_orientation_id: number; // 매핑/PATCH에 쓰이는 orientation id
  [key: string]: unknown;
}

/**
 * 카메라 생성. 두 가지 모드:
 *  - 일반: preview 이미지 업로드 (실제 스냅샷)
 *  - add-mode: preview 없이 `extraId` 만 전달 → BE 가 `extra_camera_orientation_status` 로 저장,
 *    preview_img_url 은 null. 임시 카메라용. (BE `branches/views.py:568` 의 `img is None` 분기)
 */
export const createCamera = async (params: {
  branchUid: string;
  versionId?: number;
  previewImage?: File;
  extraId?: string;
}): Promise<CreateCameraResponse> => {
  const formData = new FormData();
  if (params.previewImage) {
    formData.append("preview_img", params.previewImage);
  } else if (params.extraId != null) {
    formData.append(
      "extra_camera_orientation_status",
      JSON.stringify({ extra_id: params.extraId }),
    );
  }
  if (params.versionId != null) {
    formData.append("version", params.versionId.toString());
  }
  const { data } = await axiosMultipartInstance.post<CreateCameraResponse>(
    `branches/${params.branchUid}/pseudo-cameras/`,
    formData,
  );
  return data;
};
